import React, { Component } from 'react';

class CommentInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      comment: '',
    };
    this.handleChange = this.handleChange.bind(this);
    this.submitComment = this.submitComment.bind(this);
  }

  handleChange(event) {
    const { value } = event.target;
    this.setState({
      comment: value,
    });
  }

  submitComment() {
    this.props.handleComment(
      this.state.comment,
      this.props.username,
      this.props.commentIndex
    );
    this.setState({ comment: '' });
  }

  render() {
    const { comment } = this.state;
    // const { username } = this.props;
    // const { commentIndex } = this.props;
    return (
      <div className="comment-input">
        <textarea
          name="comment"
          id="comment"
          value={comment}
          onChange={this.handleChange}
          placeholder="Add a comment..."
        ></textarea>
        <button
          disabled={comment === ''}
          type="submit"
          onClick={this.submitComment}
        >
          Post
        </button>
      </div>
    );
  }
}

export default CommentInput;
